import { SunIcon, MoonIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";
import { useTheme } from "./ThemeContext";

/**
 * Botón para alternar entre tema claro/oscuro.
 *
 * `variant`:
 *  - "onDark"   → para usarse sobre fondos siempre oscuros (ej. la barra
 *                 negra del Navbar), que no cambian con el tema del sitio.
 *  - "onSurface" (default) → usa los tokens ui-* para adaptarse ella misma
 *                 al tema activo (ej. dentro del panel del menú móvil).
 */
export default function ThemeToggle({ variant = "onSurface", showLabel = false }) {
  const { theme, toggleTheme } = useTheme();
  const { t } = useTranslation();
  const isDark = theme === "dark";

  const colorClasses =
    variant === "onDark"
      ? "text-gray-400 hover:text-gray-200"
      : "text-ui-text-muted hover:text-ui-text";

  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-pressed={isDark}
      className={`ux-transition ux-focus-ring inline-flex items-center gap-2 rounded-md p-2 ${colorClasses}`}
      title={isDark ? t("theme.switchToLight") : t("theme.switchToDark")}
    >
      {isDark ? <SunIcon className="h-5 w-5" aria-hidden="true" /> : <MoonIcon className="h-5 w-5" aria-hidden="true" />}
      <span className={showLabel ? "text-sm font-medium" : "sr-only"}>
        {isDark ? t("theme.lightMode") : t("theme.darkMode")}
      </span>
    </button>
  );
}
